module.exports = __webpack_public_path__ + "5d526b0987f3c6cafbd79d82fd98aed2.svg";